"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSavedPage = exports.deleteSavedPage = exports.fetchPageSavedState = exports.makeAuthHeader = void 0;
var makeAuthHeader = function (token) { return ({
    Authorization: "Bearer ".concat(token),
}); };
exports.makeAuthHeader = makeAuthHeader;
var fetchPageSavedState = function (url, projectSecret, getToken) { return __awaiter(void 0, void 0, Promise, function () {
    var clerkToken, response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, getToken()];
            case 1:
                clerkToken = _a.sent();
                if (!clerkToken) return [3, 5];
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, , 5]);
                return [4, fetch("".concat(url, "/savedpages/").concat(projectSecret), {
                        headers: (0, exports.makeAuthHeader)(clerkToken),
                    })];
            case 3:
                response = _a.sent();
                if (response.status === 404) {
                    return [2, false];
                }
                return [2, true];
            case 4:
                error_1 = _a.sent();
                console.error("Error retrieving page saved status for the springboard engagement menu", error_1);
                throw error_1;
            case 5: return [2, false];
        }
    });
}); };
exports.fetchPageSavedState = fetchPageSavedState;
var deleteSavedPage = function (url, projectSecret, getToken) { return __awaiter(void 0, void 0, Promise, function () {
    var clerkToken, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                return [4, getToken()];
            case 1:
                clerkToken = _a.sent();
                if (!clerkToken) return [3, 3];
                return [4, fetch("".concat(url, "/savedpages/").concat(projectSecret), {
                        headers: (0, exports.makeAuthHeader)(clerkToken),
                        method: "DELETE",
                    })];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [3, 5];
            case 4:
                error_2 = _a.sent();
                console.error("Error unsaving page from Springboard in the springboard engagement menu", error_2);
                throw error_2;
            case 5: return [2];
        }
    });
}); };
exports.deleteSavedPage = deleteSavedPage;
var setSavedPage = function (url, projectSecret, getToken) { return __awaiter(void 0, void 0, Promise, function () {
    var clerkToken, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 6]);
                return [4, getToken()];
            case 1:
                clerkToken = _a.sent();
                if (!clerkToken) return [3, 3];
                return [4, fetch("".concat(url, "/savedpages"), {
                        headers: (0, exports.makeAuthHeader)(clerkToken),
                        method: "POST",
                        body: JSON.stringify({ pageId: projectSecret }),
                    })];
            case 2:
                _a.sent();
                return [3, 4];
            case 3: throw new Error("No Clerk token received");
            case 4: return [3, 6];
            case 5:
                error_3 = _a.sent();
                console.error("Error saving page to Springboard in the springboard engagement menu", error_3);
                throw error_3;
            case 6: return [2];
        }
    });
}); };
exports.setSavedPage = setSavedPage;
